import { Reveal, MaskedLines, LineDraw } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

export const PageHeader = ({ eyebrow, lines, sub, children, className, lineClassName }) => (
  <section className={cn("relative overflow-hidden pt-36 pb-16 sm:pt-44 sm:pb-24", className)}>
    <div className="grid-texture absolute inset-0 [mask-image:radial-gradient(ellipse_at_top,black,transparent_70%)]" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <Reveal y={16}>
        <p className="eyebrow flex items-center gap-4">
          <LineDraw className="w-10" />
          {eyebrow}
        </p>
      </Reveal>
      <MaskedLines
        as="h1"
        lines={lines}
        className="display-xl mt-6 max-w-5xl"
        lineClassName={lineClassName || ((i) => (i === lines.length - 1 && lines.length > 1 ? "font-editorial italic font-normal normal-case tracking-normal text-gold" : ""))}
        delay={0.15}
      />
      {sub && (
        <Reveal delay={0.5} className="mt-8 max-w-2xl">
          <p className="text-base leading-relaxed text-slate-400 sm:text-lg">{sub}</p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);

export const SectionHead = ({ number, eyebrow, lines, sub, right, className }) => (
  <div className={cn("mb-14 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between", className)}>
    <div>
      <Reveal y={16}>
        <p className="eyebrow flex items-center gap-4">
          <span className="text-crimson">{number}</span>
          <LineDraw className="w-10" />
          {eyebrow}
        </p>
      </Reveal>
      <MaskedLines
        as="h2"
        inView
        lines={lines}
        className="display-lg mt-6"
        lineClassName={(i) => (i === lines.length - 1 && lines.length > 1 ? "font-editorial italic font-normal normal-case tracking-normal text-gold" : "")}
      />
      {sub && (
        <Reveal delay={0.3} className="mt-6 max-w-xl">
          <p className="text-base leading-relaxed text-slate-400">{sub}</p>
        </Reveal>
      )}
    </div>
    {right && <Reveal delay={0.4}>{right}</Reveal>}
  </div>
);
